import { ROLE_LABELS, UserRoleEnum } from '../types'

export const optionsRole = [
    {
        label: ROLE_LABELS[UserRoleEnum.TECHNICIANS],
        value: UserRoleEnum.TECHNICIANS,
    },
    {
        label: ROLE_LABELS[UserRoleEnum.DISPATCHER],
        value: UserRoleEnum.DISPATCHER,
    },
    {
        label: ROLE_LABELS[UserRoleEnum.EXECUTIVES],
        value: UserRoleEnum.EXECUTIVES,
    },
]

export const optionsOnlineStatus = [
    { label: 'Online', value: 'online' },
    { label: 'Offline', value: 'offline' },
]

export const optionsSepviseStatus = [
    {
        label: 'Active',
        value: 'active',
    },
    {
        label: 'Inactive',
        value: 'inactive',
    },
]

export const optionsTeamStatus = [
    {
        label: 'Active',
        value: 'active',
    },
    {
        label: 'Busy',
        value: 'busy',
    },
]

export const optionsCharts = [
    {
        label: 'for 1 week',
        value: 'week',
    },
    {
        label: 'for 1 month',
        value: 'month',
    },
    {
        label: 'for 1 year',
        value: 'year',
    },
]

export const optionsRating = [
    {
        label: '5',
        value: '5',
    },
    {
        label: '4',
        value: '4',
    },
    {
        label: '3',
        value: '3',
    },
    {
        label: '2',
        value: '2',
    },
    {
        label: '1',
        value: '1',
    },
]
